import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Reserve_Account_Record.css';

const RENT_Reserve_Account_Record = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_RESERVE_ACCOUNT_RECORD",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_RESERVE_ACCOUNT_RECORD:-1
  });


  const [RENT_RESERVE_ACCOUNT_RECORD, setRENT_RESERVE_ACCOUNT_RECORD] = React.useState(null);
  const [RENT_RESERVE_ACCOUNT_RECORD_D, setRENT_RESERVE_ACCOUNT_RECORD_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Reserve Account Record');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_RESERVE_ACCOUNT_RECORD(clientInfo,"OpenNew");

		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_RESERVE_ACCOUNT_RECORD(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_RESERVE_ACCOUNT_RECORD(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_RESERVE_ACCOUNT_RECORD(clientInfo,"OpenNew");
		}
		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_RESERVE_ACCOUNT_RECORD(Temp_Data2);
			navigate('/RENT_Reserve_Account_Record#New',{replace:true});
		} 
		else 
			navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Reserve_Account_Record',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_RESERVE_ACCOUNT_RECORD) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_RESERVE_ACCOUNT_RECORD]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_RESERVE_ACCOUNT_RECORD){
	  for(var Sec in RENT_RESERVE_ACCOUNT_RECORD[Ele]){
		if(Sec == "id")
			Ids.push(RENT_RESERVE_ACCOUNT_RECORD[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_RESERVE_ACCOUNT_RECORD[Ele]["status"]);
		else if(Array.isArray(RENT_RESERVE_ACCOUNT_RECORD[Ele][Sec]))
			  for(var Row in RENT_RESERVE_ACCOUNT_RECORD[Ele][Sec])  // Convert to RENT_RESERVE_ACCOUNT_RECORD[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_RESERVE_ACCOUNT_RECORD[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_RESERVE_ACCOUNT_RECORD"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_RESERVE_ACCOUNT_RECORD(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD`).then((response1) => {
		if(!RENT_RESERVE_ACCOUNT_RECORD) 
			setRENT_RESERVE_ACCOUNT_RECORD(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD_D`).then((response2) => {
			setRENT_RESERVE_ACCOUNT_RECORD_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_RESERVE_ACCOUNT_RECORD_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_RESERVE_ACCOUNT_RECORD = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_RESERVE_ACCOUNT_RECORD(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_RESERVE_ACCOUNT_RECORD = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_RESERVE_ACCOUNT_RECORD = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_RESERVE_ACCOUNT_RECORD = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_RESERVE_ACCOUNT_RECORD = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_RESERVE_ACCOUNT_RECORD', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0"]=value;
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1"]=value;
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4"]=value;
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
  }; 
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4"]=value;
	//handleAddRENT_RESERVE_ACCOUNT_RECORD(Temp_Data,App_Data['RENT_RESERVE_ACCOUNT_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4",value,Temp_Data);
 	//handleLastDataRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
    setRENT_RESERVE_ACCOUNT_RECORD(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_RESERVE_ACCOUNT_RECORD) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedRENT_RESERVE_ACCOUNT_RECORD =JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
  updatedRENT_RESERVE_ACCOUNT_RECORD[Sec] = [...updatedRENT_RESERVE_ACCOUNT_RECORD[Sec], newRow];
  setRENT_RESERVE_ACCOUNT_RECORD(updatedRENT_RESERVE_ACCOUNT_RECORD);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_RESERVE_ACCOUNT_RECORD = JSON.parse(JSON.stringify(RENT_RESERVE_ACCOUNT_RECORD));
  updatedRENT_RESERVE_ACCOUNT_RECORD[sec].splice(index, 1);
  setRENT_RESERVE_ACCOUNT_RECORD(updatedRENT_RESERVE_ACCOUNT_RECORD);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Reserve Account Record`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Reserve Record ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Reserve Record ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0" type="text" className="form-control" placeholder="RENT Reserve Record ID" value={RENT_RESERVE_ACCOUNT_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Reserve Record ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1" type="text" className="form-control" placeholder="Asset ID" value={RENT_RESERVE_ACCOUNT_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Account ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2" type="text" className="form-control" placeholder="Escrow Account ID" value={RENT_RESERVE_ACCOUNT_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Account ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Period`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3" type="text" className="form-control" placeholder="Reserve Period" value={RENT_RESERVE_ACCOUNT_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Reserve Period`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Reserve Type`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Reserve Type RENT`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0"  value={RENT_RESERVE_ACCOUNT_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_0_Change} className="form-control" name="Reserve Type RENT"  >
						  <option value="Operating Reserve">Operating Reserve</option>
						  <option value="Capital Reserve">Capital Reserve</option>
						  <option value="Insurance Reserve">Insurance Reserve</option>
						  <option value="Tax Reserve">Tax Reserve</option>
						  <option value="Debt Service Reserve">Debt Service Reserve</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Reserve Type RENT
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Opening Reserve Balance USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1" type="text" className="form-control" placeholder="Opening Reserve Balance USD" value={RENT_RESERVE_ACCOUNT_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Opening Reserve Balance USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Contribution USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2" type="text" className="form-control" placeholder="Reserve Contribution USD" value={RENT_RESERVE_ACCOUNT_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Reserve Contribution USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Draw USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3" type="text" className="form-control" placeholder="Reserve Draw USD" value={RENT_RESERVE_ACCOUNT_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Reserve Draw USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Closing Reserve Balance USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4" type="text" className="form-control" placeholder="Closing Reserve Balance USD" value={RENT_RESERVE_ACCOUNT_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Closing Reserve Balance USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Minimum Required Reserve USD`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Minimum Required Reserve USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0" type="text" className="form-control" placeholder="Minimum Required Reserve USD" value={RENT_RESERVE_ACCOUNT_RECORD["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Minimum Required Reserve USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Reserve Compliance Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1"  value={RENT_RESERVE_ACCOUNT_RECORD["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_3_1_Change} className="form-control" name="Reserve Compliance Status"  >
						  <option value="Compliant">Compliant</option>
						  <option value="Below Minimum">Below Minimum</option>
						  <option value="Excess Reserve">Excess Reserve</option>
						  <option value="Pending Review">Pending Review</option>
						  <option value="Exception">Exception</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Reserve Compliance Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Reserve Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reserve Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0" type="text" className="form-control" placeholder="Reserve Document Link" value={RENT_RESERVE_ACCOUNT_RECORD["4"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Reserve Document Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0" type="text" className="form-control" placeholder="Submitted By" value={RENT_RESERVE_ACCOUNT_RECORD["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1" type="text" className="form-control" placeholder="Submitted At" value={RENT_RESERVE_ACCOUNT_RECORD["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2" type="text" className="form-control" placeholder="Reviewed By" value={RENT_RESERVE_ACCOUNT_RECORD["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3" type="text" className="form-control" placeholder="Reviewed At" value={RENT_RESERVE_ACCOUNT_RECORD["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4"  value={RENT_RESERVE_ACCOUNT_RECORD["5"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0"  value={RENT_RESERVE_ACCOUNT_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_RESERVE_ACCOUNT_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_RESERVE_ACCOUNT_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_RESERVE_ACCOUNT_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_RESERVE_ACCOUNT_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_RESERVE_ACCOUNT_RECORD_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Reserve_Account_Record;  